// src/components/Logo.tsx
import React from "react";
import LogoSvg from "../assets/glix-logo.svg";

interface LogoProps {
  width?: string;
}

const Logo: React.FC<LogoProps> = ({width}) => {

  return (
    <img
      src={LogoSvg}
      alt="React logo"
      width={width ?? "150px"}
    />
  )

};

export default Logo;
